<template>
  <div class="o-error-jumbotron" ref="errorJumbotronRef" v-if="appError">
    <button @click="handleClose" class="close-button" tabindex="0">
      <Close />
    </button>
    <h3>{{ appError.title }}</h3>
    <div class="o-error-jumbotron-context" v-html="appError.message"></div>
  </div>
</template>

<script setup lang="ts">
import Close from '@/components/shared/svg/Close.vue'
import { useErrorsStore } from '@/store/ErrorsStore'
import { storeToRefs } from 'pinia'
import { ref, watch } from 'vue'

const errorsStore = useErrorsStore()
const { appError } = storeToRefs(errorsStore)
const { clearAppError } = errorsStore
const errorJumbotronRef = ref<HTMLDivElement | null>(null)

watch(appError, newError => {
  if (newError) {
    setTimeout(() => {
      errorJumbotronRef.value?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })
    }, 600)
  }
})

const handleClose = () => {
  clearAppError()
}
</script>

<style scoped lang="scss">
.o-error-jumbotron {
  background: $red40;
  border-radius: 8px;
  margin: $spacer-3 auto 0;
  padding: $spacer-3;
  position: relative;
  max-width: $grid-breakpoint-sm;

  h3 {
    font-family: $font-family-pilat-bold;
    line-height: 24px;
    margin-bottom: $spacer-1;
  }
}
.o-error-jumbotron-context {
  color: var(--color-text-primary);
}
.close-button {
  border-radius: 50%;
  display: block;
  flex-shrink: 0;
  height: 14px;
  position: absolute;
  right: $spacer-4;
  top: $spacer-2;
  width: 14px;
}
</style>
